/* eslint-disable */

import React, { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  updateState,
  selectSubscriptionStatus,
  resetSubscriptionStatus,
  fetchSubscriptionStatusThunk,
} from "../../features/counter/counterSlice";
import { HashLink } from "react-router-hash-link";
import { setSearchTerm } from "../../store/reducers/search";
import Purchase from "../../features/subscription/purchase";
import useScreenSize from "../../hooks/useScreenSize";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDxp } from "../../authConfig";
import { QuickLinks } from "../../components/QuickLink";
import useAppModernisation from "../../hooks/useAppModernisation";
import classNames from "classnames";
import appStyles from "../../scss/app.module.scss";

import { HeadLog } from "../../components/HeadLog/HeadLog";
import { Helmet } from "react-helmet";
import { getGuidelineList } from "../../utils/getConstants";
import { HeadSearch } from "../../components/enhancedSearch/HeadSearch/HeadSearch";
import { StyledLink } from "../../components/StyledLink/StyledLink";
import useAuth from "../../hooks/useAuth";

const NavBar = React.lazy(() => import("../../components/navBar"));
const Footer = React.lazy(() => import("../../components/footer"));

const EtgAccess = (props) => {
  const dispatch = useDispatch();
  const { isLogged, authID } = useAuth();
  const { isAppMode, isEnhancedSearchEnabled } = useAppModernisation();

  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const searchSelected = searchParams.get("searchSelected");
  const { isWebScreen, isDesktop } = useScreenSize();
  const subscription = useSelector(selectSubscriptionStatus);
  const { canPurchase, hasAppliedCoupon, status, error } = subscription;
  const [isInstiution, setIsInstiution] = useState(false);
  const email = authID?.u?.["signInNames.emailAddress"];
  const guidelineList = getGuidelineList();

  useEffect(() => {
    if (!useDxp) return;
    if (process.env.REACT_APP_DISABLE_SUBSCRIPTION_VERIFICATION === "true") {
       setIsInstiution(true);
    return;
    }
    if (isLogged) {
      if (authID.u?.authenticationSource === "localAccountAuthentication") {
        // Single & multi user
        setIsInstiution(false);
        if (email) {
          if (status === "idle" || status === "failed") {
            dispatch(fetchSubscriptionStatusThunk(email));
          }
        } else {
          // If user is not logged in, reset the status
          dispatch(resetSubscriptionStatus());
        }
      } else {
        // Institution user and no need to purchase
        setIsInstiution(true);
      }
    }
  }, [authID, email, status, dispatch]);

  useEffect(() => {
    window.addEventListener("message", (event) => {
      const { type } = event.data;

      if (type === "initial") {
        dispatch(updateState({ medium: "ReactNative" }));
      }
    });

    function isInStandaloneMode() {
      return (
        window.navigator.standalone ||
        window.matchMedia("(display-mode: standalone)").matches
      );
    }

    if (isInStandaloneMode()) {
      window.addEventListener("unload", function () {
        localStorage.setItem(
          "lastVisited",
          window.location.pathname +
            window.location.search +
            window.location.hash
        );
      });

      window.addEventListener("load", function () {
        const lastVisited = localStorage.getItem("lastVisited");
        if (lastVisited) {
          navigate(lastVisited);
        }
      });
    }
  }, []);

  const openTeaser = (guidelineName) => {
    const ftxtcontenturl = `/viewTopic/?guidelinePage=${encodeURIComponent(
      guidelineName
    )}&etgAccess=true`;
    const guidelinePage = guidelineName.replace(/ /g, "_");
    const data = {
      ditaPath: `${guidelinePage}/`,
      queryString: {
        guidelinePage: encodeURIComponent(guidelineName),
        etgAccess: "true",
      },
      displayBanner: true,
    };
    dispatch(updateState(data));
    navigate(ftxtcontenturl);
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission
    // if (event.keyCode === 13) {
    dispatch(setSearchTerm(search));
    // submitform(event.target.value, push);
    navigate(
      "/searchAction/?appendedinputbuttons=" + encodeURIComponent(search)
    );

    // }
    setSearch("");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setSearch(value);
  };

  const handleBIClick = (event) => {
    document.getElementById("drugIndexModal").classList.add("in");
    document.getElementById("drugIndexModal").style.display = "block";

    document.querySelectorAll(".modal-backdrop").forEach((element) => {
      element.classList.add("in");
      element.style.display = "block";
    });
  };

  const renderWhatsNew = () => {
    return (
      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 nopadding">
        <h4 className="section-heading">What's new </h4>
        <p></p>
        <div id="whatsnewId">
          <p>
            {" "}
            The March 2025 release of <i>Therapeutic Guidelines </i>includes a
            complete revision of more than 200 clinical topics in the Antibiotic
            guidelines, as well as targeted changes to infection-related content
            across the guidelines.
          </p>
          <p>
            To find out what's new in the Antibiotic guidelines, including which
            topics have been revised and which are under revision, see{" "}
            <a
              target="_blank"
              href="https://www.tg.org.au/products/therapeutic-guidelines/updates/antibiotic/ "
            >
              <u>What’s new in Antibiotic</u>
            </a>
            .<br />
          </p>
          <p>
            {" "}
            We welcome feedback from our community; please contact{" "}
            <a target="_blank" href="mailto:feedback@tg.org.au">
              <u>
                <b>feedback@tg.org.au</b>
              </u>
            </a>
            .
          </p>
        </div>
      </div>
    );
  };
  const renderQuickLinksAndWhatsNew = () => {
    return !isAppMode ? (
      <>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <h4 className="section-heading">Quick links</h4>
          <p></p>
          <ul className="list-unstyled quicklinks">
            <li>
              <a
                href="https://ccmsfiles.tg.org.au/s6/PDFs/Antibiotic-Summary-table.pdf?type=Antibiotic prescribing in primary care - summary table"
                title="Antibiotic prescribing in primary care - summary table"
                target="_blank"
                rel="noopener noreferrer"
              >
                Antibiotic prescribing in primary care - summary table
              </a>
            </li>
            <li>
              <a
                href="https://ccmsfiles.tg.org.au/s6/PDFs/ABG16-Surgical-antibiotic-prophylaxis-Collated-table-v4.pdf?type=Surgical prophylaxis - summary tables"
                title="Surgical prophylaxis - summary tables"
                rel="noopener noreferrer"
                target="_blank"
              >
                Surgical prophylaxis - summary tables
              </a>
            </li>
            <li>
              <HashLink
                role="menuitem"
                aria-label="Patient information and useful PDFs"
                to="/patientInfo/"
                title="Patient information and useful PDFs"
              >
                Patient information and useful PDFs
              </HashLink>
            </li>
            <li>
              <HashLink
                role="menuitem"
                aria-label="Pregnancy and breastfeeding"
                to="/viewTopic?guidelinePage=quicklinks&etgAccess=true"
              >
                Pregnancy and breastfeeding
              </HashLink>
            </li>
            <li>
              <HashLink
                role="menuitem"
                aria-label="Calculators"
                to="/calculator/ccbwcalc"
                title="Calculators"
              >
                Calculators
              </HashLink>
            </li>
            <li>
              <HashLink
                role="menuitem"
                aria-label="Tables and figures"
                to="/tables-and-figures/"
                title="Tables and figures"
              >
                Tables and figures
              </HashLink>
            </li>
          </ul>
        </div>
        {renderWhatsNew()}
      </>
    ) : null;
  };

  const renderAboutTG = () => (
    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <h4 className="section-heading">About Therapeutic Guidelines</h4>
      <div id="descriptionId">
        <p></p>
        <p>
          <em>Therapeutic Guidelines</em> is recognised as a leading source of
          accurate, independent and practical treatment advice for a wide range
          of clinical conditions. It includes explicit instructions for therapy,
          assisting practitioners in making decisions to ensure their patients
          receive optimum treatment.
        </p>
        <p>
          Licence options&nbsp;are available to meet a wide range of needs - for
          single users, practices and clinics, or larger organisations.
        </p>
        <p>
          <em>Therapeutic Guidelines</em> now features a new look, improved
          search functionality and navigation. An app for Apple and Android
          devices is now included in the subscription, available on and offline
          - ideal for having vital information at the point of care.
        </p>
        <p></p>
      </div>
    </div>
  );

  const renderPurchase = () => (
    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 nopadding">
      <Purchase hasAppliedCoupon={hasAppliedCoupon} />
    </div>
  );

  const mainIconClass = (className) => {
    return classNames(
      {
        dotIcon: !isAppMode,
        squareIcon: isAppMode,
      },
      className
    );
  };

  const containerAppClass = classNames("container", {
    [`${appStyles.container}`]: isAppMode,
    "dart-etgAccess": !isAppMode,
  });

  const unorderedListClass = classNames("list-unstyled", "guideline-areas", {
    [`${appStyles.guideline}`]: isAppMode,
  });

  const anchorClass = classNames({
    [`${appStyles.anchor}`]: isAppMode,
    [`text-sm`]: isAppMode,
  });

  const canShowDrugIndexButton = !canPurchase || isInstiution || !useDxp;

  const appGuidelineNavigation = (guideline) => { 
    const normalizeGuideline = guideline.replaceAll(' ', '_');
    navigate(`/app/nav/${normalizeGuideline}`);
  };

  return (
    <>
      <Suspense fallback={<div className="loader"></div>}>
        {isAppMode ? (
          <>
            <Helmet>
              <meta name="theme-color" content="#F1F1F1" />
            </Helmet>

            {
              <HeadSearch
                className="padding-15"
                {...{ push: navigate, isDesktop, isAppMode, searchSelected }}
              ></HeadSearch>
            }

            {!isLogged ? <HeadLog></HeadLog> : null}
          </>
        ) : (
          <NavBar push={navigate} />
        )}
        {isAppMode ? <QuickLinks {...{ isLogged }}></QuickLinks> : null}
        <div className={containerAppClass}>
          <div className="sectionBlockLayout row">
            <div
              className={classNames("row-container", {
                // row: isAppModern,
                // "row-container": !isAppModern,
              })}
            >
              <div
                className={classNames("col-sm-5 columnBlockLayout ", {
                  // "pt-1 pb-1": isAppModern,
                  // columnBlockLayout: !isAppModern,
                  "col-lg-4 col-md-4 col-sm-5": !isAppMode,
                })}
              >
                <div
                  className={classNames({
                    "section-heading": !isAppMode,
                    [`${appStyles.sectionHeading}`]: isAppMode,
                  })}
                >
                  <h2 className={classNames({ "text-md semibold": isAppMode })}>
                    Guidelines
                  </h2>
                </div>
                <ul className={unorderedListClass} role="navigation" aria-label="Guidelines Navigation">
                  {guidelineList.map(
                    ({ iconClassSuffix, linkText, onClickProps }, index) => (
                      <li key={`ind-${index}`}>
                        <span className={mainIconClass(iconClassSuffix)} />
                        <a
                          data-toggle="tooltip"
                          href=""
                          aria-label={linkText}
                          onClick={() => {
                            isAppMode
                              ? appGuidelineNavigation(onClickProps)
                              : openTeaser(onClickProps);
                          }}
                        >
                          {linkText}
                          <span className="goto-arrow">
                            <i className="fa banner-head-topic fa-angle-right" />
                          </span>
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </div>

              {!isAppMode && (
                <div className="col-lg-8 col-md-8 col-sm-7">
                  {isDesktop && (
                    <>
                      {!isEnhancedSearchEnabled ? (
                        <form
                          id="searchformGPeTgld"
                          name="searchformGP"
                          onSubmit={handleSubmit}
                          className="hidden-xs"
                        >
                          <div className="input-group search-widget custom-filter">
                            <div className="form-group">
                              <input
                                type="text"
                                name="appendedinputbuttons"
                                id="globalserach"
                                className="form-control input-lg ui-autocomplete-input"
                                placeholder="Search"
                                autoComplete="on"
                                value={search}
                                onChange={handleChange}
                              />
                            </div>
                            <span className="input-group-btn">
                              {" "}
                              <a
                                className="btn nopadding"
                                type="button"
                                onClick={handleSubmit}
                              >
                                {" "}
                              </a>{" "}
                            </span>
                            <div className="mTop6px text-center qtn-font helpMark"></div>
                          </div>
                        </form>
                      ) : (
                        <div>
                          <HeadSearch
                            {...{ push: navigate, isDesktop, isAppMode }}
                          ></HeadSearch>
                        </div>
                      )}
                    </>
                  )}
                  {canShowDrugIndexButton && (
                    <>
                      <div className="clearfix"></div>

                      {isEnhancedSearchEnabled ? (
                        <div
                          className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mgbtm20px"
                          id="drugnameSearch1"
                        >
                          <StyledLink
                            icon="Medicine"
                            className="size-14"
                            title="Browse Drug Index"
                            description="Lookup a drug"
                            onClick={(e) => handleBIClick(e)}
                            data={{
                              toggle: "modal",
                              target: "#drugIndexModal",
                            }}
                          ></StyledLink>
                        </div>
                      ) : (
                        <div className="col-lg-6 mgbtm20px">
                          <div
                            className="BrowsedrugBtn col-lg-12 "
                            id="drugnameSearch1"
                            style={{ position: "relative" }}
                          >
                            <button
                              type="button"
                              onClick={(e) => handleBIClick(e)}
                              className="btn css_btn_class btn-block "
                              data-toggle="modal"
                              data-target="#drugIndexModal"
                            >
                              Browse drug index
                            </button>
                            <span className=" text-center qtn-font helpMark"></span>
                          </div>
                          <div className="clearfix"></div>
                        </div>
                      )}

                      <div className="clearfix"></div>
                    </>
                  )}
                  {!isAppMode && (
                    <>
                      {!useDxp ? (
                        renderQuickLinksAndWhatsNew()
                      ) : isInstiution ? (
                        renderQuickLinksAndWhatsNew()
                      ) : status === "succeeded" || status === "idle" ? (
                        !canPurchase ? (
                          renderQuickLinksAndWhatsNew()
                        ) : isWebScreen ? (
                          <>
                            {renderAboutTG()}
                            {!isAppMode ? renderPurchase() : null}
                          </>
                        ) : !isAppMode ? (
                          renderAboutTG()
                        ) : null
                      ) : (
                        <div>Loading...</div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        {!window.Microsoft && !isAppMode && <Footer />}
      </Suspense>
    </>
  );
};

export default EtgAccess;
